import { CartEmptyIcon } from '@kohler-dsm-library/kohler-icons';
import clsx from 'clsx';
import React from 'react';
import { DsmColor } from '../../constants/colors.mjs';
import { polymorphicFactory } from '../../factory/factory.utils.mjs';
import { Typography } from '../../Foundations/Typography/Typography.mjs';
import { Flex } from '../../Layout/Flex/Flex.mjs';
import { Box } from '../../Other/Box/Box.mjs';
import classes from './CartBadge.module.css.mjs';
import { iconMap } from './CartBadge.utils.mjs';

const CartBadge = polymorphicFactory(
  (props, ref) => {
    const { component = "div", className, digit, thickness = "default", withBoundingBox = true, textColor, ...rest } = props;
    const digitString = digit?.toString();
    const classNames = clsx("kohler-cart-badge-root", className, classes.cartBadgeRoot);
    const Icon = digitString && digitString !== "0" ? iconMap[thickness][digitString.length || 0] : CartEmptyIcon;
    return /* @__PURE__ */ React.createElement(
      Box,
      {
        position: "relative",
        className: classNames,
        component,
        ref,
        textColor: textColor ?? DsmColor.ContentSecondary,
        ...rest
      },
      /* @__PURE__ */ React.createElement(Icon, { withBoundingBox, style: { maxWidth: "100%", display: "block" } }),
      digitString && digitString !== "0" && /* @__PURE__ */ React.createElement(Flex, { align: "center", position: "absolute", right: digitString.length > 2 ? 0 : 4, left: digitString.length > 2 ? 10 : 8, top: 0 }, /* @__PURE__ */ React.createElement(Typography, { component: "span", size: "tag-s", display: "flex", width: "100%", justifyContent: "center", textColor: "inherit" }, digitString))
    );
  }
);

export { CartBadge };
